import {
    CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL,
    FETCH_PERFORMANCE_CREATIVES_ERROR,
    FETCH_PERFORMANCE_CREATIVES_START,
    FETCH_PERFORMANCE_CREATIVES_SUCCESS,
    OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL,
    PERFORMANCE_CREATIVE_REPLACE,
    PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER,
    PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME,
    PerformanceCreativesActions,
    SELECT_PERFORMANCE_CREATIVES,
    SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR,
    SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE,
    SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL
} from '../../actions/banners-edit/performanceCreatives';
import { EditBannersState, EditedBanner } from '../../typings/bannersEditState';
import { AdvType } from '../../typings/domain';

export function performanceCreativesReducer(
    state: EditBannersState,
    action: PerformanceCreativesActions
): EditBannersState {
    switch (action.type) {
        case SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    isChooseModalOpen: action.value,
                    modalData: action.payload,
                    selectedCreatives: {},
                    creativesAndGroupsList: [],
                    creativeIds: [],
                    creatives: {},
                    searchFieldByIdOrName: '',
                    creativeIdToReplace: ''
                }
            };

        case OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    isConstructorOpen: true,
                    constructorType: action.constructorType
                }
            };

        case CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    isConstructorOpen: false,
                    constructorType: undefined,
                    constructorCreativeGroupId: undefined
                }
            };

        case SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    constructorCreativeGroupId: action.constructorCreativeGroupId
                }
            };

        case FETCH_PERFORMANCE_CREATIVES_START:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    creativesLoading: true
                }
            };

        case FETCH_PERFORMANCE_CREATIVES_SUCCESS:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    creativesAndGroupsList: action.payload.creativesAndGroupsList,
                    selectedGroupCreatives: action.payload.selectedGroupCreatives,
                    creativeIds: action.payload.creativeIds,
                    creatives: action.payload.creatives,
                    creativeGroups: action.payload.creativeGroups,
                    creativesLoadedCount: action.payload.creativesLoadedCount,
                    creativesLoading: false
                }
            };

        case FETCH_PERFORMANCE_CREATIVES_ERROR:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    creativesLoading: false
                }
            };

        case SELECT_PERFORMANCE_CREATIVES:
            const selectedIds = action.creativeIds;

            const newSelectedCreatives = {
                ...state.performanceCreatives.selectedCreatives
            };

            selectedIds.forEach(selectedId => {
                if (action.value) {
                    newSelectedCreatives[selectedId] = true;
                } else {
                    delete newSelectedCreatives[selectedId];
                }
            });

            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    selectedCreatives: newSelectedCreatives
                }
            };

        case PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    order: action.order
                }
            };

        case PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    searchFieldByIdOrName: action.text
                }
            };

        case SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE:
            return {
                ...state,
                performanceCreatives: {
                    ...state.performanceCreatives,
                    creativeIdToReplace: action.creativeId
                }
            };

        case PERFORMANCE_CREATIVE_REPLACE:
            const { modalData, creativeIdToReplace, creatives, selectedGroupCreatives } = state.performanceCreatives;
            const creative = creatives[creativeIdToReplace];
            const bannerId = modalData && modalData.bannerId;

            // нет данных о баннере где нужно сделать замену креатива
            // или нет данных по выбранному креативу то ни чего не делаем
            if (!bannerId || !creativeIdToReplace || !creative) {
                return state;
            }

            const banner: EditedBanner = state.banners[bannerId];

            if (banner.bannerType !== AdvType.PERFORMANCE || (banner.creativeReplaced && !banner.serverCreativeId)) {
                return state;
            }

            // если заменяем креатив в 1й раз, сохраняем id креатива сохраненного на backend'е
            // если заменяем повторно, то оставляем ранее сохраненное значение
            const serverCreativeId = banner.creativeReplaced ? banner.serverCreativeId : String(banner.creative.id);

            const updatedBanner = {
                ...banner,
                creativeReplaced: true,
                serverCreativeId,
                creative: {
                    id: creative.id,
                    name: creative.name,
                    url: creative.url,
                    height: creative.height,
                    width: creative.width,
                    layout: creative.layout,
                    groupId: creative.groupId,
                    groupName: creative.groupName
                }
            };

            const newSelectedGroupCreatives = { ...selectedGroupCreatives };
            newSelectedGroupCreatives[creative.id] = true;
            delete newSelectedGroupCreatives[bannerId];

            return {
                ...state,
                banners: {
                    ...state.banners,
                    [bannerId]: updatedBanner
                },
                performanceCreatives: {
                    ...state.performanceCreatives,
                    selectedGroupCreatives: newSelectedGroupCreatives
                }
            };

        default:
            return state;
    }
}
